import { Maybe } from "@/types";

export type PackageContextType = {
  packageId: number;
  groupSize?: number;
  arrivalDate?: string;
  drawerId: string;
};

export type DatePlannerDatumType = {
  book: boolean;
  date: Date;
  disabled?: boolean;
  duration: number;
  price: Maybe<number>;
};

export type DatePlannerDataType = Array<DatePlannerDatumType>;

export enum AppTabKey {
  HOTEL_GOLF = "hotel_golf",
  HOTEL_FLIGHT_GOLF = "hotel_flight_golf",
}
